// Send consentString to requesting iframes
window.addEventListener('message', function(event) {
    if(event.data.action == 'reqConsentString') {

        try {
            __tcfapi('getTCData', null, function(e) {

                console.log("SPPM: sending tcString to player", e.tcString);

                msg = {
                    action: 'sendConsentString',
                    consentString: e.tcString
                };
                event.source.postMessage(msg, '*')

            });
        }
        catch(e) {
            console.log("SPPM: reqConsentString error, tcfapi not ready?", e);
        }

    }


    if(event.data.action == 'reqVendorGrant') {

        if(event.data && event.data.hasOwnProperty('vendorId')) {

            try {
                __consentHandler.vendorGrant(event.data.vendorId).then(function(){
                    console.log("SPPM: __consentHandler.vendorGrant granted");
                    msg = {
                        action: 'vendorGrant',
                        vendorId: event.data.vendorId,
                        grants: true,
                    };
                    event.source.postMessage(msg, '*')
                }).catch(function(e){
                    console.log("SPPM: __consentHandler.vendorGrant not granted");
                    msg = {
                        action: 'vendorGrant',
                        vendorId: event.data.vendorId,
                        grants: false,
                    };
                    event.source.postMessage(msg, '*')
                });
            }
            catch(e) {

                console.log("SPPM: __consentHandler.vendorGrant ERROR",e);

                if (
                    window.location.hostname === 'www.rtl2.de' ||
                    window.location.hostname === 'rtl2.de' ||
                    window.location.hostname === 't-rtl2de.rtl2.de' ||
                    window.location.hostname === 'i-rtl2de.rtl2.de'
                ) {
                    msg = {
                        action: 'vendorGrant',
                        vendorId: event.data.vendorId,
                        grants: false,
                    };
                    event.source.postMessage(msg, '*')
                }
                else {
                    // allow everything for non rtl2.de websites (for now)
                    msg = {
                        action: 'vendorGrant',
                        vendorId: event.data.vendorId,
                        grants: true,
                    };
                    event.source.postMessage(msg, '*')
                }
            }
        }

    }
});



// WEBPACK FOOTER //
// ./src/scripts/sendConsentString.js